import React, { useEffect } from 'react'

const FEATURABLE_SCRIPT_ID = 'featurable-reviews-script'
const FEATURABLE_WIDGET_ID = 'featurable-9b8141ae-7855-4351-b7d5-8a3a55b2148d'

const GoogleReviewsSection = () => {
  // useEffect(() => {
  //   let timeoutId

  //   const loadFeaturable = () => {
  //     const widget = document.getElementById(FEATURABLE_WIDGET_ID)
  //     if (!widget) return

  //     widget.innerHTML = ''
  //     widget.setAttribute('data-featurable-async', '')

  //     const existingScript = document.getElementById(FEATURABLE_SCRIPT_ID)
  //     if (existingScript) existingScript.remove()

  //     const script = document.createElement('script')
  //     script.id = FEATURABLE_SCRIPT_ID
  //     script.src = 'https://featurable.com/assets/bundle.js'
  //     script.defer = true
  //     script.charset = 'UTF-8'
  //     document.body.appendChild(script)
  //   }

  //   timeoutId = window.setTimeout(loadFeaturable, 0)

  //   return () => {
  //     window.clearTimeout(timeoutId)
  //   }
  // }, [])

  return (
    <>
    {/* <section className="google-reviews-section py-5">
      <div className="container">
        <div className="text-center mb-4">
          <h2 className="pb-3 h5 app-section-eyebrow">GOOGLE REVIEWS</h2>
          <h3 className="display-6 fw-bold text-white mb-3">What Clients Say About Metatech Official</h3>
        </div>
        <div className="google-reviews-widget-wrap">
          <div id={FEATURABLE_WIDGET_ID} data-featurable-async=""></div>
        </div>
      </div>
    </section> */}
    </>
  )
}

export default GoogleReviewsSection
